/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { Request } from '../models';
import { SecurityGroupMemberViewIEnumerableResponse } from '../models';
import { TrustTeamMemberExternalIdRequest } from '../models';
import { TrustTeamMemberPracticeRequest } from '../models';
import { TrustTeamMemberRequest } from '../models';
import { TrustTeamMemberViewIEnumerableResponse } from '../models';
import { TrustTeamMemberViewResponse } from '../models';
/**
 * TrustTeamMemberApi - axios parameter creator
 * @export
 */
export const TrustTeamMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Trust Team Member Supervisors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetSupervisorsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TrustTeamMember/GetSupervisors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Member
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet: async (memberId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            if (memberId === null || memberId === undefined) {
                throw new RequiredError('memberId','Required parameter memberId was null or undefined when calling apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet.');
            }
            const localVarPath = `/api/v2/TrustTeamMember/GetTrustTeamMemberById/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Member by PracticeId
         * @param {TrustTeamMemberPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost: async (body?: TrustTeamMemberPracticeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TrustTeamMember/GetTrustTeamMemberByPracticeId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Members
         * @param {Request} [body] 
         * @param {boolean} [showInvestigatorOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetTrustTeamMembersPost: async (body?: Request, showInvestigatorOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TrustTeamMember/GetTrustTeamMembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (showInvestigatorOnly !== undefined) {
                localVarQueryParameter['showInvestigatorOnly'] = showInvestigatorOnly;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save Trust Team Member
         * @param {TrustTeamMemberRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberSaveTrustTeamMemberPost: async (body?: TrustTeamMemberRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TrustTeamMember/SaveTrustTeamMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Active Directory Trust Team Members
         * @param {string} [keyword] 
         * @param {boolean} [nonTrustTeamMemberOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberSearchSecurityGroupMembersGet: async (keyword?: string, nonTrustTeamMemberOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TrustTeamMember/SearchSecurityGroupMembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (nonTrustTeamMemberOnly !== undefined) {
                localVarQueryParameter['nonTrustTeamMemberOnly'] = nonTrustTeamMemberOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Team Member
         * @param {TrustTeamMemberExternalIdRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost: async (body?: TrustTeamMemberExternalIdRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TrustTeamMember/TrustInvestigator/GetTrustTeamMemberByExternalId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrustTeamMemberApi - functional programming interface
 * @export
 */
export const TrustTeamMemberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Trust Team Member Supervisors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberGetSupervisorsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustTeamMemberViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberGetSupervisorsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Member
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(memberId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustTeamMemberViewResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(memberId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Member by PracticeId
         * @param {TrustTeamMemberPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost(body?: TrustTeamMemberPracticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustTeamMemberViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Members
         * @param {Request} [body] 
         * @param {boolean} [showInvestigatorOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberGetTrustTeamMembersPost(body?: Request, showInvestigatorOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustTeamMemberViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberGetTrustTeamMembersPost(body, showInvestigatorOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save Trust Team Member
         * @param {TrustTeamMemberRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberSaveTrustTeamMemberPost(body?: TrustTeamMemberRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberSaveTrustTeamMemberPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Active Directory Trust Team Members
         * @param {string} [keyword] 
         * @param {boolean} [nonTrustTeamMemberOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberSearchSecurityGroupMembersGet(keyword?: string, nonTrustTeamMemberOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityGroupMemberViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberSearchSecurityGroupMembersGet(keyword, nonTrustTeamMemberOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Team Member
         * @param {TrustTeamMemberExternalIdRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost(body?: TrustTeamMemberExternalIdRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustTeamMemberViewResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TrustTeamMemberApi - factory interface
 * @export
 */
export const TrustTeamMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Returns Trust Team Member Supervisors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetSupervisorsGet(options?: any): AxiosPromise<TrustTeamMemberViewIEnumerableResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberGetSupervisorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Member
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(memberId: number, options?: any): AxiosPromise<TrustTeamMemberViewResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Member by PracticeId
         * @param {TrustTeamMemberPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost(body?: TrustTeamMemberPracticeRequest, options?: any): AxiosPromise<TrustTeamMemberViewIEnumerableResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Trust Team Members
         * @param {Request} [body] 
         * @param {boolean} [showInvestigatorOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberGetTrustTeamMembersPost(body?: Request, showInvestigatorOnly?: boolean, options?: any): AxiosPromise<TrustTeamMemberViewIEnumerableResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberGetTrustTeamMembersPost(body, showInvestigatorOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save Trust Team Member
         * @param {TrustTeamMemberRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberSaveTrustTeamMemberPost(body?: TrustTeamMemberRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberSaveTrustTeamMemberPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Active Directory Trust Team Members
         * @param {string} [keyword] 
         * @param {boolean} [nonTrustTeamMemberOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberSearchSecurityGroupMembersGet(keyword?: string, nonTrustTeamMemberOnly?: boolean, options?: any): AxiosPromise<SecurityGroupMemberViewIEnumerableResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberSearchSecurityGroupMembersGet(keyword, nonTrustTeamMemberOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Team Member
         * @param {TrustTeamMemberExternalIdRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost(body?: TrustTeamMemberExternalIdRequest, options?: any): AxiosPromise<TrustTeamMemberViewResponse> {
            return TrustTeamMemberApiFp(configuration).apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrustTeamMemberApi - object-oriented interface
 * @export
 * @class TrustTeamMemberApi
 * @extends {BaseAPI}
 */
export class TrustTeamMemberApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Returns Trust Team Member Supervisors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberGetSupervisorsGet(options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberGetSupervisorsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Trust Team Member
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(memberId: number, options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Trust Team Member by PracticeId
     * @param {TrustTeamMemberPracticeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost(body?: TrustTeamMemberPracticeRequest, options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberGetTrustTeamMemberByPracticeIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Trust Team Members
     * @param {Request} [body] 
     * @param {boolean} [showInvestigatorOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberGetTrustTeamMembersPost(body?: Request, showInvestigatorOnly?: boolean, options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberGetTrustTeamMembersPost(body, showInvestigatorOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save Trust Team Member
     * @param {TrustTeamMemberRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberSaveTrustTeamMemberPost(body?: TrustTeamMemberRequest, options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberSaveTrustTeamMemberPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Active Directory Trust Team Members
     * @param {string} [keyword] 
     * @param {boolean} [nonTrustTeamMemberOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberSearchSecurityGroupMembersGet(keyword?: string, nonTrustTeamMemberOnly?: boolean, options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberSearchSecurityGroupMembersGet(keyword, nonTrustTeamMemberOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Trust Team Member
     * @param {TrustTeamMemberExternalIdRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost(body?: TrustTeamMemberExternalIdRequest, options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV2TrustTeamMemberTrustInvestigatorGetTrustTeamMemberByExternalIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
